import * as types from "../actions/types/gettingStarted.types";

const initialState = {
    isDocsUpload: false,
    inivtedSignatoriesState: "idle",
    invitedSignatoriesList: [],
};

export const gettingStartedReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_IS_DOCS_UPLOAD:
            return {
                ...state,
                isDocsUpload: true,
            };


        case types.GET_INVITED_SIGNATORIES_STARTED:
            return {
                ...state,
                inivtedSignatoriesState: "loading",
            };
        case types.GET_INVITED_SIGNATORIES_SUCEEDED:
            return {
                ...state,
                inivtedSignatoriesState: "success",
                invitedSignatoriesList: action.payload
            };
        case types.GET_INVITED_SIGNATORIES_FAILED:
            return {
                ...state,
                inivtedSignatoriesState: "failed",
            };
        default:
            return state;
    }
};
